import React from 'react';

import { IconTextTag } from '@travel/ui';
import { cx } from '@travel/utils';

import styles from './skeleton.module.scss';

const Skeleton = () => {
  return (
    <article className={styles.container}>
      <div className={styles.mediaContainer}>
        <div className={cx(styles.skeleton, styles.reservationMedia)} />
      </div>
      <div className={styles.tagContainer}>
        <IconTextTag haveBorder isEmpty color="default" className={styles.tagSpacing} />
        <IconTextTag haveBorder isEmpty color="default" />
      </div>
      <div className={styles.actionContainer}>
        <div className={styles.action} />
        <div className={styles.action} />
        <div className={styles.action} />
      </div>
    </article>
  );
};

export default Skeleton;
